import { 
  Edit, 
  Trash2, 
  Building2,
  Building,
  Users,
  Upload,
  X,
  Eye
} from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { LoadingSpinner } from '../common'

function CompanyList({ 
  companies, 
  isLoading, 
  onEdit, 
  onDelete, 
  onToggleStatus, 
  onLogoSelect, 
  onLogoDelete,
  isUploadingLogo,
  isDeletingLogo,
  userRole
}) {
  const navigate = useNavigate()
  if (isLoading) {
    return <LoadingSpinner size="lg" className="h-64" />
  }

  return (
    <div className="card">
      <div className="card-content p-0">
        <div className="overflow-x-auto">
          <table className="table">
            <thead className="table-header">
              <tr className="table-row">
                <th className="table-head">Company</th>
                <th className="table-head">Contact</th>
                <th className="table-head">Location</th>
                <th className="table-head">Users</th>
                <th className="table-head">Status</th>
                <th className="table-head">Actions</th>
              </tr>
            </thead>
            <tbody className="table-body">
              {companies.map((company) => (
                <tr 
                  key={company.id} 
                  className={`table-row ${userRole === 2 ? 'cursor-pointer hover:bg-secondary-50' : ''}`}
                  onClick={userRole === 2 ? () => navigate(`/companies/${company.id}`) : undefined}
                >
                  <td className="table-cell">
                    <div className="flex items-center">
                      <div className="h-8 w-8 bg-primary-100 rounded-full flex items-center justify-center overflow-hidden">
                        {company.logo ? (
                          <img 
                            src={"http://localhost:8080" + company.logo} 
                            alt={`${company.name} logo`}
                            className="h-full w-full object-cover"
                            onError={(e) => {
                              console.error('Image load error:', company.logo, e);
                              e.target.style.display = 'none';
                            }}
                            onLoad={() => {
                              console.log('Image loaded successfully:', company.logo);
                            }}
                          />
                        ) : (
                          <Building2 className="h-4 w-4 text-primary-600" />
                        )}
                      </div>
                      <div className="ml-3">
                        <div className="text-sm font-medium text-secondary-900">
                          {company.name}
                        </div>
                        <div className="text-sm text-secondary-500">
                          {company.website}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="table-cell">
                    <div className="text-base text-secondary-900">{company.email}</div>
                    <div className="text-base text-secondary-500">{company.phone}</div>
                  </td>
                  <td className="table-cell">
                    <div className="text-base text-secondary-900">
                      {company.city}, {company.state}
                    </div>
                    <div className="text-base text-secondary-500">
                      {company.pincode}
                    </div>
                  </td>
                  <td className="table-cell">
                    <div className="flex items-center text-base text-secondary-900">
                      <Users className="h-4 w-4 mr-1" />
                      {company.users?.length || 0} users
                    </div>
                  </td>
                  <td className="table-cell">
                    <span className={`badge ${company.isActive ? 'badge-success' : 'badge-danger'}`}>
                      {company.isActive ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td className="table-cell">
                    <div className="flex items-center space-x-2">
                      {userRole === 2 ? (
                        // Company Owner - only view button
                        <button
                          onClick={(e) => {
                            e.stopPropagation()
                            navigate(`/companies/${company.id}`)
                          }}
                          className="text-primary-600 hover:text-primary-900"
                          title="View Company Details"
                        >
                          <Eye className="h-4 w-4" />
                        </button>
                      ) : (
                        // Super Admin - full actions
                        <>
                          <button
                            onClick={(e) => {
                              e.stopPropagation()
                              onEdit(company)
                            }}
                            className="text-primary-600 hover:text-primary-900"
                            title="Edit Company"
                          >
                            <Edit className="h-4 w-4" />
                          </button>
                          <button
                            onClick={(e) => {
                              e.stopPropagation()
                              onToggleStatus(company)
                            }}
                            className={company.isActive ? 'text-danger-600 hover:text-danger-900' : 'text-success-600 hover:text-success-900'}
                            title={company.isActive ? 'Deactivate Company' : 'Activate Company'}
                          >
                            {company.isActive ? <Building className="h-4 w-4" /> : <Building2 className="h-4 w-4" />}
                          </button>
                          {company.logo ? (
                            <button
                              onClick={(e) => {
                                e.stopPropagation()
                                onLogoDelete(company.id)
                              }}
                              className="text-danger-600 hover:text-danger-900"
                              title="Delete Logo"
                              disabled={isDeletingLogo}
                            >
                              <X className="h-4 w-4" />
                            </button>
                          ) : (
                            <label className="text-primary-600 hover:text-primary-900 cursor-pointer" title="Upload Logo">
                              <Upload className="h-4 w-4" />
                              <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => onLogoSelect(e, company.id)}
                                className="hidden"
                                id={`logo-upload-${company.id}`}
                              />
                            </label>
                          )}
                          <button
                            onClick={(e) => {
                              e.stopPropagation()
                              onDelete(company)
                            }}
                            className="text-danger-600 hover:text-danger-900"
                            title="Delete Company"
                          >
                            <Trash2 className="h-4 w-4" />
                          </button>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default CompanyList
